import { FetchError } from 'ofetch';
import { Auth } from '~/types/Auth';

declare global {
  interface IEAuth extends IAuth {
    logged(): boolean;
    login(data?: IAuth): Promise<any>;
    logout(): Promise<any>;
    refresh(): Promise<any>;
    fetchProfile(): Promise<any>;
  }

  // class EAuth extends Auth implements IEAuth {
  //   // Logged is authenticated
  //   public logged(): boolean;
  //   // Login method
  //   public login(data?: IAuth): Promise<any>;
  //   // Logout method
  //   public logout(): Promise<any>;
  //   // Refresh method
  //   public refresh(): Promise<any>;
  //   // Fetch profile
  //   public fetchProfile(): Promise<any>;
  // }
};

export class EAuth extends Auth implements IAuth {
  // Logged is authenticated
  public logged(): boolean {
    return useSanctumAuth()?.isAuthenticated?.value;
  };

  // Login method
  public async login(data?: IAuth): Promise<any> {
    let auth = {};
    if (data)
      auth = data;
    else
      auth = this;
    if (Auth.instanceOfUser(auth) && !this.logged()) {
      try {
        auth = JSON.parse(JSON.stringify(auth)); // CANNOT SEND CLASS VIA API ONLY OBJECTS
        return await useSanctumAuth()?.login(auth);
      } catch (e) {
        if (e instanceof FetchError && (e as FetchError).response?.status === 422)
          console.log((e as FetchError).response?._data?.errors);

        return e;
      }
    }
  };

  // Logout method
  public async logout(): Promise<any> {
    if (this.logged())
      try {
        clearNuxtData();
        return await useSanctumAuth()?.logout();
      } catch (e) {
        if (e instanceof FetchError && (e as FetchError).response?.status === 422)
          console.log((e as FetchError).response?._data?.errors);

        return e;
      }
  };

  // Refresh method
  public async refresh(): Promise<any> {
    try {
      return await useSanctumAuth()?.refreshIdentity();
    } catch (e) {
      if (e instanceof FetchError && (e as FetchError).response?.status === 422)
        console.log((e as FetchError).response?._data?.errors);

      return e;
    }
  };

  // Fetch profile
  public async fetchProfile(): Promise<any> {
    const client = useSanctumClient();

    return await client(useSanctumConfig()?.endpoints?.user, {
      method: 'GET'
    });
  };
};

export {}; // Keeps it a valid module
